'use client'

import { useClockTimestamp } from '@/components/utils/clock/useClockTimestamp'
import { useNoSsr } from '@/hooks/useNoSsr'

type ClockTimestampFormatterProps = {
  template: string
  timezone?: string
  className?: string
}

export function ClockTimestampFormatter({
  template,
  timezone,
  className,
}: ClockTimestampFormatterProps) {
  const timestamp = useClockTimestamp(timezone)
  return (
    <time className={className} dateTime={timestamp.format()} suppressHydrationWarning>
      {useNoSsr(() => timestamp.format(template))}
    </time>
  )
}
